import React, { createContext, useState } from "react";

const PageContext = createContext();

const PageContextProvider = ({ children }) => {
  const [pageName, setPageName] = useState("Dashboard");
  const [calendarExpand, setCalendarExpand] = useState(true);
  const [taskDuedate, setTaskDuedate] = useState(new Date());
  const [taskname, setTaskname] = useState("");

  const [container, setContainer] = useState([]);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const [activeContainerIndex, setActiveContainerIndex] = useState(null);

  const [openQuestion, setOpenQuestion] = useState(false);
  const [openQuestionSetting, setOpenQuestionSetting] = useState(false);

  const [showShearModel, setShowShearModel] = useState(false);
  const [link, setLink] = useState(null);
  //ALL  QUESTION PROPERTIES

  //Tag functions

  const [isSectionMoveModal, setShowSectionMoveModal] = useState(false);
  // const
  return (
    <PageContext.Provider
      value={{
        pageName,
        setPageName,
        calendarExpand,
        setCalendarExpand,
        taskname,
        setTaskname,
        taskDuedate,
        setTaskDuedate,
        openQuestion,
        setOpenQuestion,
        activeQuestion,
        setActiveQuestion,
        activeContainerIndex,
        setActiveContainerIndex,
        openQuestionSetting,
        setOpenQuestionSetting,
        showShearModel,
        setShowShearModel,
        link,
        setLink,
        isSectionMoveModal,
        setShowSectionMoveModal,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export { PageContext, PageContextProvider };
